import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58271f82"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "subtotals"
}

import { onMounted } from 'vue'
import { subtotalStore } from '@/stores/v2/subtotal'
import { headerStore } from '@/stores/header'


export default /*#__PURE__*/_defineComponent({
  __name: 'WoononSubtotalWidget',
  setup(__props) {

onMounted(() => {
  subtotalStore().getSubtotals()
})

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Subtotalen",
    class: "subtotal-widget"
  }, {
    default: _withCtx(() => [
      (!_unref(subtotalStore)().loading && _unref(subtotalStore)().subtotals)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_a_row, { class: "no-mb" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  span: 16,
                  class: "price-label"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Modulair:")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 8,
                  class: "price"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.modular.subtotal_text), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { class: "no-mb" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  span: 16,
                  class: "price-label"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ruwbouw:")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 8,
                  class: "price"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.carcass.subtotal_text), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { class: "no-mb" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  span: 16,
                  class: "price-label"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Afbouw 1:")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 8,
                  class: "price"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.completion1.subtotal_text), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { class: "no-mb" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  span: 16,
                  class: "price-label"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Afbouw 2:")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 8,
                  class: "price"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.completion2.subtotal_text), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { class: "no-mb" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  span: 16,
                  class: "price-label"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Afbouw 3:")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 8,
                  class: "price"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.completion3.subtotal_text), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_unref(headerStore)().extraPhaseEnabled)
              ? (_openBlock(), _createBlock(_component_a_row, {
                  key: 0,
                  class: "no-mb"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      span: 16,
                      class: "price-label"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Extra:")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      span: 8,
                      class: "price"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.extra.subtotal_text), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_divider),
            _createVNode(_component_a_row, { class: "no-mb" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  span: 16,
                  class: "price-label"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Woningprijs:")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 8,
                  class: "price"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.building.subtotal_text), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 16,
                  class: "price-label"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Meer- en minderwerk:")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 8,
                  class: "price"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.all_phases.subtotal_text), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_divider),
                _createVNode(_component_a_col, {
                  span: 16,
                  class: "price-label"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Totaal:")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 8,
                  class: "price"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.total_text), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createBlock(_component_a_skeleton, {
            key: 1,
            active: ""
          }))
    ]),
    _: 1
  }))
}
}

})